<template>
  <div>
    <div class="m-b-10 f-s-10 m-t-10">
      <b class="text-inverse ts-uppercase">{{ $t('homePage.subject') }}</b>
    </div>
    <ts-loading-banner :loading="loading">
      <div class="overflow-auto" style="min-height: 5rem; max-height: 10rem">
        <div
          class="widget-list widget-list-rounded m-b-10 inverse-mode"
          v-if="sunjectLists.length > 0"
        >
          <a
            href="#"
            class="widget-list-item ts-whitespace-no-wrap"
            v-for="(subject, index) in sunjectLists"
            :key="index"
            @click.prevent="homework(subject)"
          >
            <div class="widget-list-media icon">
              <i
                class="fas fa-journal-whills text-white"
                :class="(bgName = randomBackground())"
              ></i>
            </div>
            <div class="widget-list-content">
              <h4 class="widget-list-title">{{ subject.subject_name }}</h4>
            </div>
            <div class="widget-list-action text-right">
              <span class="badge badge-orange m-r-2" :class="bgName">{{
                getTotalBySubject({ subject_id: subject.subject_id })
              }}</span>
              <i class="fa fa-angle-right fa-lg text-muted"></i>
            </div>
          </a>
        </div>
        <div class="widget-list widget-list-rounded m-b-10" v-else>
          <a class="widget-list-item ts-whitespace-no-wrap">
            <div class="widget-list-content text-center">
              <h4 class="widget-list-title">{{ $t('homePage.noSubject') }}</h4>
            </div>
          </a>
        </div>
      </div>
    </ts-loading-banner>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
export default {
  name: 'subject',
  data() {
    return {
      sunjectLists: [],
      homeworkPending: 0,
      loading: false,
      backgrounds: [
        'bg-indigo',
        'bg-blue',
        'bg-purple',
        'bg-pink',
        'bg-red',
        'bg-orange',
        'bg-green',
        'bg-teal',
        'bg-primary',
        'bg-success',
        'bg-info',
        'bg-warning',
        'bg-danger'
      ]
    }
  },
  computed: {
    ...mapState('home/staffHomework', ['resources', 'teacher_id']),
    ...mapGetters('home/staffHomework', ['getTotalBySubject'])
  },
  methods: {
    fetchSubject() {
      this.loading = true
      this.$store
        .dispatch('home/staffHomework/fetchSubjectByTeacher')
        .then(response => {
          this.sunjectLists = response
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },
    randomBackground() {
      return this.backgrounds[
        Math.floor(Math.random() * this.backgrounds.length)
      ]
    },
    homework(record) {
      this.$store.commit(
        'home/staffHomeworkLinkFromHome/SET_SUBJECT_ID',
        record.subject_id
      )
      this.$store.commit(
        'home/staffHomeworkLinkFromHome/SET_TEACHER_ID',
        this.teacher_id
      )
      this.$router.push({
        name: 'home-homework'
      })
    }
  },
  watch: {
    resources: function(value) {
      if (value) {
        this.fetchSubject()
      }
    }
  }
}
</script>
